import React from 'react'
import styled from 'styled-components'

const QuestionMeta = ({ commentAmount, useTranslate}) => {

  return (
    <Container>
      {commentAmount} {useTranslate("discussion.answer_amount")}
    </Container>
  )
}

export default QuestionMeta;

const Container = styled.div`
  font-size: 14px;
  color: #5F7D95;
  display: flex;
  align-items: center;
  white-space: nowrap;
  
  .icon-heart {
    margin-right: 5px;
  }
`;


// WEBPACK FOOTER //
// ./src/components/discussion/question-meta.js